import { Button, Card, Center, Stack, Text, Title } from "@mantine/core";
import { useAuth } from "../auth/AuthContext";
import { PasswordChangeForm } from "../components/PasswordChangeForm";

/**
 * Shown when a bootstrap password still has to be replaced. The server blocks
 * every other endpoint until it is (PASSWORD_CHANGE_REQUIRED), so this is not
 * a suggestion that can be dismissed - a password an administrator handed
 * over, or that was printed in a deployment log, must not be usable to do real
 * work.
 *
 * The same form is reachable any time from the profile page; this screen is
 * only the forced presentation of it.
 */
export function ChangePassword() {
  const { user, refresh, signOut } = useAuth();

  return (
    <Center mih="100dvh" p="lg" bg="gray.0">
      <Card withBorder radius="md" padding="xl" w="100%" maw={420}>
        <Stack gap="md">
          <Stack gap={4}>
            <Title order={4}>Set a new password</Title>
            <Text fz="md" c="gray.7">
              {user?.name} — your current password was issued for setup only,
              so it has to be replaced before you can continue.
            </Text>
          </Stack>

          <PasswordChangeForm
            submitLabel="Set password and continue"
            onDone={refresh}
          />

          <Button variant="subtle" color="gray" onClick={signOut}>
            Sign out
          </Button>
        </Stack>
      </Card>
    </Center>
  );
}
